import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1364bb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trustdata-trust-team" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maintain trust data", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Trust Team", -1))
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "search-inputs" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_9 = { class: "checkbox-button" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Investigators only")
], -1))
const _hoisted_11 = {
  class: "bottom-half",
  style: {"width":"100%","overflow":"auto"}
}
const _hoisted_12 = { class: "ls-table trust-team-table" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["colspan"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["colspan"]
const _hoisted_23 = { "data-label": "Display name" }
const _hoisted_24 = { "data-label": "Email" }
const _hoisted_25 = { "data-label": "Role" }
const _hoisted_26 = { "data-label": "Supervisor" }
const _hoisted_27 = { "data-label": "Charge amount" }
const _hoisted_28 = { "data-label": "Number of routine investigations" }
const _hoisted_29 = {
  key: 0,
  class: "ml-2 warning fal fa-exclamation-triangle fa-lg"
}
const _hoisted_30 = { "data-label": "Number of cause driven investigations" }
const _hoisted_31 = {
  key: 0,
  class: "ml-2 warning fal fa-exclamation-triangle fa-lg"
}
const _hoisted_32 = { "data-label": "Overdue timesheet" }
const _hoisted_33 = {
  key: 0,
  class: "ml-2 warning fal fa-exclamation-triangle fa-lg"
}
const _hoisted_34 = { "data-label": "Actions" }
const _hoisted_35 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Search name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchKeyword]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("label", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.investigatorOnly) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.investigatorOnly]
            ]),
            _hoisted_10
          ])
        ]),
        (_ctx.showAddUserButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary mr-2",
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.addNewMember()), ["prevent","stop"]))
            }, "Add new user"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("table", _hoisted_12, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(h.text), 1),
                  (h.sortable)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', h.sortMethod])
                      }, _hoisted_16, 2))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_13))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_18)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_20)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredTeamMembers.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, "No Records", 8, _hoisted_22)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredTeamMembers.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.filteredTeamMembers, (m) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_23, _toDisplayString(m.displayName), 1),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(m.email), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(m.userGroup?.name ?? ''), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(m.supervisor?.displayName ?? ''), 1),
                        _createElementVNode("td", _hoisted_27, [
                          (!!m.userGroup && m.userGroup?.name !== 'Trust Admin')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(m.chargeAmount ?? ''), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          (!!m.userGroup && m.userGroup?.name !== 'Trust Admin')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(m.totalRoutines ?? '') + " ", 1),
                                (m.totalRoutines >= 40)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          (!!m.userGroup && m.userGroup?.name !== 'Trust Admin')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(m.totalCauseDrivens ?? '') + " ", 1),
                                (m.totalCauseDrivens >= 3)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_31))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          (!!m.userGroup && m.userGroup?.name !== 'Trust Admin')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$calculateHours(m.totalMissingTime)) + " ", 1),
                                (m.totalMissingTime)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml transparent ml-1",
                            onClick: $event => (_ctx.goToInvestigator(m))
                          }, " View ", 8, _hoisted_35)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}